module.exports = __WEBPACK_EXTERNAL_MODULE_102__;


//////////////////
// WEBPACK FOOTER
// external "aws-sdk/global"
// module id = 102
// module chunks = 0